import type { ReadConfig } from 'api-read-hook';
import type { HydraCollection } from '../../types';

import { useApiRead } from 'api-read-hook';
import { makeQueryString } from '../../util';

export type V = {
  '@id': string;
  '@type': 'Tag';
  id: string;
  internalName: string;
  userFacingName: string;
  slug: string | null;
  category: {
    '@id': string;
    '@type': 'TagCategory';
    name: string;
  };
};

export type W = {
  internalName: string;
  userFacingName: string;
  category: string;
};

export function useReadCollectionAll(
  queryParams?: { internalName?: string; 'order[category.name]'?: string },
  options?: ReadConfig,
) {
  return useApiRead<HydraCollection<V>>(
    `/tags/all${makeQueryString(queryParams)}`,
    options,
  );
}

export function useReadItem(id: string, options?: ReadConfig) {
  return useApiRead<V>(`/tags/${id}`, options);
}
